import { redirectToLogin, Auth } from '@core/auth';
import { isPublic } from '@core/router/utils';

const loadUser = async (to, from, next) => {
    if (isPublic(to) || Auth().onboarding) {
        next();
    } else {
        try {
            await Auth().setCurrentUser();

            if (to.name && to.name.startsWith('InvestorOnboarding')) {
                next({ name: 'SettingsProfile' });
            } else {
                // Clean up the IdP hint so we don't look messy
                const query = to.query;
                if (query.idp_hint) {
                    // Persist the IdP alias for future redirects
                    localStorage.setItem('idp_hint', query.idp_hint);

                    delete query.idp_hint;
                    next({ replace: true, path: to.path, query });
                } else {
                    next();
                }
            }
        } catch (error) {
            const httpStatus = error?.response?.status;

            if (httpStatus === 404) {
                await Auth().setRegistration();
                next();
            } else if (httpStatus < 500) {
                const params = {
                    app_uri: window.location.host
                };
                const currentUrl = new URL(window.location.href);
                const storedIdpHint = localStorage.getItem('idp_hint');

                // Using the IdP Hint to tell keycloak where to go.
                // Transforming to kc_idp_hint for KC but means we can keep the parameter name generic
                // We're using the window location rather than the to object as we need to pass the
                // full current URL in as the redirect URL and we should delete idp_hint from the return
                if (storedIdpHint) {
                    params.kc_idp_hint = storedIdpHint;
                } else if (currentUrl.searchParams.has('idp_hint')) {
                    const idpHint = currentUrl.searchParams.get('idp_hint');
                    if (idpHint) {
                        localStorage.setItem('idp_hint', idpHint);
                        params.kc_idp_hint = idpHint;
                    }
                    currentUrl.searchParams.delete('idp_hint');
                }

                params.rd = currentUrl.toString();
                return redirectToLogin(params);
            }
        }
    }
};

export default loadUser;
